import { createApiRequestType, strictObjectAccess } from '@ackee/redux-utils';

import { EntityKey } from 'constants/index';

const apiRequestType = createApiRequestType({ modulePrefix: EntityKey.ELEVATOR_STATE });

export const fetchElevatorStateTypes = strictObjectAccess({
    ...apiRequestType({ typePrefix: 'FETCH_ELEVATOR_STATE_' }),
});
